export namespace TeamLibraryConst {
  export enum FileSizeUnit {
    b = 1024,
    kb = 1024,
  }

  export enum MaxFileSizeUnit {
    mb = FileSizeUnit.kb * FileSizeUnit.b
  }

  export enum MaxFileSize {
    Model = 300 * MaxFileSizeUnit.mb // 300 MB
  }

  export enum FileStatus {
    FileValid = 0,
    FileSizeError = 1,
    FileTypeError = 2,
    FileDimensionError = 3,
    FileCountError = 4,
  }

  export enum MaxFileSizeUnitString {
    mb = 'MB',
  }

  export enum ModelThumbnailDimension {
    width = 320,
    height = 287,
  }

  export enum LibraryCategoriesStateId {
    UnderConstruction = 0,
    Hidden = 5,
    Active = 10,
    Deprecated = 999,
  }

  export const FileStatusMessage: Record<FileStatus, string> = {
    [FileStatus.FileValid]: '',
    [FileStatus.FileSizeError]: `Exceeds ${MaxFileSize.Model / MaxFileSizeUnit.mb}${MaxFileSizeUnitString.mb}`,
    [FileStatus.FileTypeError]: 'Filetype not supported',
    [FileStatus.FileDimensionError]: 'Image dimension not supported',
    [FileStatus.FileCountError]: 'Maximum number of files exceeded',
  }

  export const LibraryModalAllowedReferenceType: string[] = ['.pdf']

  export const LibraryEntryMaxReferencePDFs: number = 3

  /** Max file size for reference document uploads (shared by library entry and tenant context). */
  export const ReferenceFileMaxSizeMB: number = 30
  export const ReferenceFileMaxSizeBytes: number = ReferenceFileMaxSizeMB * MaxFileSizeUnit.mb
}
